"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var paymentSummaryStyles = makeStyles_1.default(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        container: (_b = {
                display: 'flex'
            },
            _b[breakpoints.up('sm')] = {
                position: function (_a) {
                    var summary = _a.summary;
                    return (!!summary ? 'static' : 'absolute');
                },
            },
            _b[breakpoints.down('xs')] = {
                position: 'static',
            },
            _b.right = 0,
            // @todo remove this and add a component: JourneySelectionStep.labelId: 'translation__key'
            _b.top = '-56px',
            _b),
        transactionLabelContainer: {
            display: 'flex',
        },
        transactionLabel: {
            lineHeight: 2,
        },
        icon: {},
    });
}, { name: 'Checkout4_PaymentSummaryClasses' });
exports.default = paymentSummaryStyles;
